// Example presets with images, prompts and results for AI Poses
export interface AIPosesExamplePreset {
    id: number;
    name: string;
    clothPreview: string;
    fashionModelPreview?: string;
    prompt: string;
    results: string[];
}

export const tryonExamplePresets: AIPosesExamplePreset[] = [
    {
        id: 1,
        name: 'Kurti',
        clothPreview: "https://storage.googleapis.com/xdesign-d72cd.appspot.com/generated_image/ai_poses/Yqsl85WkdWellAJHbVgrZhu9lBS2/390395fd-b5d5-4c66-9136-e4b90c07996b.jpg/a58de44e-5186-4d9a-b86e-a6c1c797492b",
        fashionModelPreview: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=400&q=80",
        prompt: '',
        results: [
            "https://storage.googleapis.com/xdesign-d72cd.appspot.com/generated_image/ai_poses/Yqsl85WkdWellAJHbVgrZhu9lBS2/60d1497a-f547-4435-ab3c-6ef1fbcddd8d_1_4fba66b7-1278-4374-90be-10de6ac293f8.jpg/cb6bc22e-26b3-4730-b497-16704c431f99"
        ]
    },
    {
        id: 2,
        name: 'Long Dress',
        clothPreview: "https://fal.media/files/penguin/P4411GTCncgQxOoramtZ7_3640a7d91b5b41b3b082822cc58d00a1.jpg",
        prompt: "",
        results: [
            "https://storage.googleapis.com/xdesign-d72cd.appspot.com/uploaded_image/ai_poses_images/lMpe6oraQRRBYDYmBJyIqydYvTz1/b2d0c34e-8abb-487b-af54-6180e8a2dae5_1_6b98ad9e-b85c-4e4e-b6d7-f9fa3d0ea694.jpg/5f2d371d-c88e-441d-90eb-31d37b64fc31",
            "https://storage.googleapis.com/xdesign-d72cd.appspot.com/uploaded_image/ai_poses_images/lMpe6oraQRRBYDYmBJyIqydYvTz1/32b53e1c-9a37-488e-a2ba-a8e53d9e4532_1_a95d5b54-12b7-4b4a-ad98-23fed13ab248.jpg/c03792ec-0fa9-4124-bd03-597ab7083390"
        ]
    },
    {
        id: 3,
        name: 'Long Dress',
        clothPreview: 'https://storage.googleapis.com/xdesign-d72cd.appspot.com/generated_image/ai_poses/Yqsl85WkdWellAJHbVgrZhu9lBS2/14f54536-64ac-499a-b040-51327a8244c2.webp/69fb8518-9556-4dae-989a-b5fb8f86cf88',
        prompt: '',
        results: [
            'https://storage.googleapis.com/xdesign-d72cd.appspot.com/generated_image/ai_poses/Yqsl85WkdWellAJHbVgrZhu9lBS2/d4836218-dcb9-4fb8-941b-0dd088cb0b9e_1_855fedd9-3fcc-4739-8545-7d54c344186a.jpg/0e6e7244-890b-42e6-8858-cbe55a3f416f'
        ]
    }
];

export type ExamplePreset = AIPosesExamplePreset;
